<template>
  <div class="header-mobile">
    <div class="header-mobile-content">
      <logo type="night"/>
      <span class="burger" @click="toggleBodyClass">
        <span/>
      </span>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo';

export default {
  components: {
    Logo,
  },
  data () {
    return {
      opened: false,
    }
  },
  methods: {
    toggleBodyClass () {
      this.opened = !this.opened;
      document.body.setAttribute('class', this.opened ? 'openPopup' : '');
    }
  }
}
</script>

<style lang="scss">
.header-mobile {
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  display: none;
  background: #fff;
  z-index: 100;
  @media (max-width: 767px) {
    display: block;
  }
}
.header-mobile-content {
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  display: flex;
}
.burger {
  position: relative;
  display: block;
  width: 30px;
  height: 15px;
  span {
    display: block;
    width: 100%;
    height: 3px;
    background: #c3c3c3;
    cursor: pointer;
    position: absolute;
    transition: all .3s ease;

    &:before,
    &:after {
      transition: all .3s ease;
      content: '';
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background: #c3c3c3;
      margin: 12px 0 0;
    }
    &:after {
      margin: 6px 0 0;
    }
  }
}
body.openPopup {
  .burger span {
    transform: translateY(10px) rotate(45deg);
    margin: -8px 0 0;
    &:before,
    &:after {
      margin: 0px 0 0;
      transform: rotate(90deg)
    }
  }
}
</style>



// WEBPACK FOOTER //
// HeaderBarMobile.vue?6d1d9fdb